
import AppSaleEdit from "@/components/sales/SaleEdit.vue";
import {Sale, SaleExtraFields} from "@/models/base";
import { SaleService } from "@/services/sale-service";
import { PendingChangesNotifier } from "@/utils/pending-changes-notifier";
import Vue from "vue";
import { ConfirmResult } from "winfakt-vue-components";
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import { TranslateResult } from "vue-i18n";
import {DossierConfigService, ToolbarService} from "@/services";

export default Vue.extend({
	data() {
		let warningText = () => {
			return "test";
		};
		return {
			sale: new Sale(),
			pendingChangesNotifier: new PendingChangesNotifier(this, "saleString", {warningText}),
			ready: false,
			state: null as null | SaleEditState,
			ToolbarService
		};
	},
	computed: {
		saleString():string {
			return JSON.stringify(this.sale.getJSON());
		},
		pendingChangesWarningText(): string{
			return this.$ct("save-confirm",{type: this.saleName, id: this.sale.ComputedFriendlyID}).toString();
		},
		saleName(): String {
			return this.sale.Type.Name.getTranslation(this.sale.getLng()).toLowerCase();
		},
		title():TranslateResult{
			return this.ToolbarService.title;
		},
	},
	methods: {
		async onSaved(sale:Sale) {
			this.sale = sale;
			await this.$nextTick();
			this.pendingChangesNotifier.changesPending = false;
		},
		async close(){
			this.$router.push("/purchase-documents");
		},
	},
	async created() {
		let saleTypeId = parseInt((this.$route.query.typeId as string) || "1") || 1;
		let allSaleTypes = SaleService.getTypes(2);
		let saleType = allSaleTypes.find(s=>s.ID == saleTypeId);
		if (saleType){
			this.sale.Type = saleType;
			this.sale.TypeID = saleType.ID;
		}else{
			this.sale.Type = allSaleTypes[0];
			this.sale.TypeID = allSaleTypes[0].ID;
		}
		let id = parseInt(this.$route.params.id || "0");
		if (id) {
			this.sale = await SaleService.getSale(id);
			await this.$nextTick();
			this.pendingChangesNotifier.changesPending = false;
		}else if (this.$route.query.fromJson){
			this.sale = new Sale(JSON.parse(this.$route.query.fromJson as string));
			this.sale.ID = 0;
		}else{
			if (!this.sale.ExtraFields){
				this.sale.ExtraFields = new SaleExtraFields();
			}
			DossierConfigService.getExtraFieldNamesConfigs().SaleNames.setDefaultValues(this.sale.ExtraFields);
		}
		this.ready = true;
		this.pendingChangesNotifier = new PendingChangesNotifier(this, "saleString", {warningText: ()=>this.pendingChangesWarningText});
	},
	components: {
		AppSaleEdit
	},
	i18nEx: {
		componentPrefix: "components.sales"
	},
	async beforeRouteLeave(to, from, next) {
		let result = await this.pendingChangesNotifier.askToSave();
		if (result == ConfirmResult.CANCEL){
			return;
		}
		if (result == ConfirmResult.YES) {
			if(this.state && this.pendingChangesNotifier.changesPending){
				if (!this.sale.ContactID) {
					this.$wf.notify(this.$ct("error-contact-empty").toString(), "danger", 3500, "exclamation-triangle");
					return false;
				}
				this.state.openSaveModal();
				return;
			}
		}
		this.$emit("parent-should-refresh");
		next();
	}
});
